import { Pagination } from "services/search";
import { createApiCall, paginatedApiCall } from "../createApiCall";
import { transformErrorResponse } from "../transformation";
import { transformReport, transformReportRow } from "./transformations";
import { Report, ReportRow } from "./types";
import { DataWithPagination } from "../types";
import { filesApi } from "../config";

/*---------------------------------------------------------------------------------------
  SEARCH
-----------------------------------------------------------------------------------------*/

export const getReportsAPI = async (
  pagination: Pagination,
  name?: string | null
): Promise<DataWithPagination<ReportRow>> => {
  let path = `/v1/reports?name=`;

  if (name) path += `${name}`;

  return await paginatedApiCall(path, pagination, transformReportRow);
};

/*---------------------------------------------------------------------------------------
  INFO
-----------------------------------------------------------------------------------------*/
export const getReportAPI = async (id: string): Promise<Report> => {
  const response = await createApiCall(
    {
      path: `/v1/reports/${id}`,
      method: "GET",
    },
    {
      getMessage: {
        error: (error: any) => `${transformErrorResponse(error)}`,
      },
    }
  )();

  return transformReport(response.data);
};

/*---------------------------------------------------------------------------------------
  Report C02 Consumption
-----------------------------------------------------------------------------------------*/
export const getReportC02ConsumptionAPI = async (year: string): Promise<Blob> => {
  const response = await filesApi({
    url: `/v1/reports/C02Consumption/generate?y=${year}`,
    method: "GET",
    responseType: "blob",
  });

  return new Blob([response.data], { type: "application/pdf" });
};


